<div *ngIf="reportPicture.hasInspectionSummaryLink" [style]="summaryLinkStyle" [style.left]="reportPicture.titleLeft"
  [style.top]="getSummaryLinkTop()">
  <ng-container *ngIf="!isSaveHtml">
    <a [style]="anchorLinkStyle" [routerLink]="" (click)="scrollToHashLink(summaryPageTableId)">Back to summary</a>
  </ng-container>
  <ng-container *ngIf="isSaveHtml">
    <a href="#{{summaryPageTableId}}" (click)="scrollToHashLink(summaryPageTableId)">Back to summary</a>
  </ng-container>
</div>
<div [style]="reportPictureStyle" *ngIf="isFirst" [style.top]="reportPicture.titleTop"
  [style.Left]="reportPicture.titleLeft" [style.width]="reportPicture.titleWidth"
  [style.height]="reportPicture.titleHeight" [style.z-index]="reportPicture.titleZIndex"
  [style.border]="reportPicture.titleBorderStyle" [style.border-color]="reportPicture.titleBorderColor"
  [style.border-width]="reportPicture.titleBorderWidth" [style.background-color]="reportPicture.titleBackgroundColor"
  [style.justify-content]="reportPicture.titleJustifyContent" [style.align-items]="reportPicture.titleAlignItems"
  [style.padding-right]="reportPicture.titlePaddingRight" [style.padding-bottom]="reportPicture.titlePaddingBottom"
  [style.padding-left]="reportPicture.titlePaddingLeft" [style.padding-top]="reportPicture.titlePaddingTop">
  <div [style]="textInlineStyle" [style.color]="reportPicture.titleFontColor"
    [style.font-size]="reportPicture.titleFontSize" [style.font-family]="reportPicture.titleFontFamily"
    [style.font-style]="reportPicture.titleFontStyle" [style.font-weight]="reportPicture.titleFontWeight"
    [style.text-align]="reportPicture.titleTextAlign" [style.vertical-align]="reportPicture.titleVerticalAlign"
    [style.line-height]="reportPicture.titleLineHeight">
    <ng-container>{{reportPicture.titleText }}</ng-container>
  </div>
</div>
<table [style]="reportPictureStyle" [ngStyle]="getTableStyle()" [style.width]="reportPicture.tableWidth"
  [style.height]="reportPicture.tableHeight">
  <tbody>
    <tr [style]="reportPictureThStyle + trBorderStyle" [style.height]="reportPicture.tableHeaderHeight"
      [style.font-size]="reportPicture.tableHeaderFontSize" [style.font-family]="reportPicture.tableHeaderFontFamily"
      [style.text-align]="reportPicture.tableHeaderHorizontalAlign"
      [style.background-color]="reportPicture.tableHeaderBackgroundColor">
      <ng-container *ngFor="let column of reportPicture.tableColumns; index as i">
        <th [style.width]="reportPicture.getThWidth(column)" [style.overflow]="'hidden'" [style.padding]="0">
          <ng-container *ngIf="column.isHeaderVertical">
            <div [ngClass]="{'report-picture-th-vertical': column.isHeaderVertical}"
              [style.font-size]="reportPicture.tableHeaderFontSize"
              [style.font-family]="reportPicture.tableHeaderFontFamily" [style.padding]="column.padding"
              [style.margin-left]="getMarginLeft(column)">
              <div [style]="beforeStyle"></div>
              {{ column.header }}
            </div>
          </ng-container>
          <ng-container *ngIf="!column.isHeaderVertical">
            <div [style.font-size]="reportPicture.tableHeaderFontSize"
              [style.font-family]="reportPicture.tableHeaderFontFamily" [style.padding]="column.padding">{{
              column.header }}</div>
          </ng-container>
        </th>
      </ng-container>
    </tr>

    <tr *ngFor="let data of tableData; index as ti" [style]="tableDataStyle" [style.width]="reportPicture.tableWidth"
      [style.height]="calcTrHeight() + sizeUnit">
      <ng-container *ngFor="let column of reportPicture.tableColumns; index as ci">
        <td *ngIf="rowSpans[ti][ci] !== 0" [style]="reportPictureThStyle" [attr.rowspan]="rowSpans[ti][ci]"
          [style.font-size]="column.fontSize + sizeUnit" [style.font-family]="column.fontFamily"
          [style.text-align]="column.horizontalAlign" [style.vertical-align]="column.verticalAlign"
          [style.padding]="column.padding" [style]="getTableRowStyle(ci + 1)">
          <ng-container *ngIf="column.isColumnVertical">
            <div [style.overflow]="'hidden'" [style.word-break]="'normal'" [style.white-space]="'pre-wrap'"
              [style.line-height]="1" [style.white-space]="'normal'" [style.transform-origin]="'50% 50%'"
              [style.height]="isBackgroundColorStyle(column) ? '100%' : ''"
              [style]="getTableColumnVerticalStyle(rowHeight, getColumnWidth(column))">
              <app-report-column [pageKey]="pageKey" [column]="column" [columns]="reportPicture.tableColumns" [data]="data"
                [trHeight]="rowHeight" [sizeUnit]="sizeUnit" [pictureKey]="pictureKey"></app-report-column>
            </div>
          </ng-container>
          <ng-container *ngIf="!column.isColumnVertical">
            <div [style.display]="'block'" [style.overflow]="'hidden'" [style.word-break]="'normal'"
              [style.white-space]="'normal'" [style.max-height]="calcTrHeightForColumn(column, data) + sizeUnit"
              [style.height]="isBackgroundColorStyle(column) ? '100%' : ''">
              <app-report-column [pageKey]="pageKey" [column]="column" [columns]="reportPicture.tableColumns" [data]="data"
                [tableWidth]="tableWidthNum" [tableHeight]="tableHeightNum"
                [pageBreakRow]="reportPicture.defaultPageBreakRowCount" [tableHeaderHeight]="tableHeaderHeightNum"
                [trHeight]="rowHeight" [sizeUnit]="sizeUnit" [pictureKey]="pictureKey"></app-report-column>
            </div>
          </ng-container>
        </td>
      </ng-container>
    </tr>
    <tr *ngFor="let row of insertEmptyRows;index as ti" [style.height]="calcTrHeight() + sizeUnit">
    </tr>
  </tbody>
</table>
